import { ObjectId } from "bson";

export interface OrganizationFile {
    fileid: string;
    organizationId: ObjectId;
    url: string;
    uploadDate?: Date;
}

export const organizationFileItemKeys = ["fileid", "url", "uploadDate"] as const;

export type OrganizationFileItem = Pick<OrganizationFile, typeof organizationFileItemKeys[number]>;
